var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRdMarketlist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_684_37217)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6826 10.0176H12.3076C11.966 10.0176 11.6826 9.73424 11.6826 9.39258C11.6826 9.05091 11.966 8.76758 12.3076 8.76758H16.6826C17.0243 8.76758 17.3076 9.05091 17.3076 9.39258C17.3076 9.73424 17.0326 10.0176 16.6826 10.0176Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93249 10.6522C7.77415 10.6522 7.61582 10.5939 7.49082 10.4689L6.86582 9.84388C6.62415 9.60221 6.62415 9.20221 6.86582 8.96055C7.10749 8.71888 7.50749 8.71888 7.74915 8.96055L7.93249 9.14388L9.36582 7.71055C9.60749 7.46888 10.0075 7.46888 10.2492 7.71055C10.4908 7.95221 10.4908 8.35221 10.2492 8.59388L8.37415 10.4689C8.25749 10.5856 8.09915 10.6522 7.93249 10.6522Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6826 15.8516H12.3076C11.966 15.8516 11.6826 15.5682 11.6826 15.2266C11.6826 14.8849 11.966 14.6016 12.3076 14.6016H16.6826C17.0243 14.6016 17.3076 14.8849 17.3076 15.2266C17.3076 15.5682 17.0326 15.8516 16.6826 15.8516Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.93249 16.4842C7.77415 16.4842 7.61582 16.4259 7.49082 16.3009L6.86582 15.6759C6.62415 15.4342 6.62415 15.0342 6.86582 14.7926C7.10749 14.5509 7.50749 14.5509 7.74915 14.7926L7.93249 14.9759L9.36582 13.5426C9.60749 13.3009 10.0075 13.3009 10.2492 13.5426C10.4908 13.7842 10.4908 14.1842 10.2492 14.4259L8.37415 16.3009C8.25749 16.4176 8.09915 16.4842 7.93249 16.4842Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4993 20.9596H9.49935C4.97435 20.9596 3.04102 19.0263 3.04102 14.5013V9.5013C3.04102 4.9763 4.97435 3.04297 9.49935 3.04297H14.4993C19.0243 3.04297 20.9577 4.9763 20.9577 9.5013V14.5013C20.9577 19.0263 19.0243 20.9596 14.4993 20.9596ZM9.49935 4.29297C5.65768 4.29297 4.29102 5.65964 4.29102 9.5013V14.5013C4.29102 18.343 5.65768 19.7096 9.49935 19.7096H14.4993C18.341 19.7096 19.7077 18.343 19.7077 14.5013V9.5013C19.7077 5.65964 18.341 4.29297 14.4993 4.29297H9.49935Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_684_37217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdMarketlist);
export default __webpack_public_path__ + "static/media/R&DMarketlist.1f65759d8d28672d27aa99fef2801791.svg";
export { ForwardRef as ReactComponent };